import request from '../../../shared/request'

export function getJobSiteWorkOrders(job_id) {
  return request(`/job/job_site_work_orders/${job_id}/`)
}

export function getJobSiteWorkOrderItems(work_order_id) {
  return request(`/job/job_site_work_orders/${work_order_id}/items`)
}

export function createWorkOrder(payload) {
  return request(`/job/job_site_work_orders/${payload.job_id}/`, {
    method: 'POST',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function updateWorkOrder(payload) {
  return request(`/job/job_site_work_orders/${payload.work_order_id}/`, {
    method: 'PUT',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function deleteWorkOrder(payload) {
  return request(`/job/job_site_work_orders/${payload.work_order_id}/`, {
    method: 'DELETE',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function markTaskComplete(task_id) {
  return request(`/job/job_site_work_orders/${task_id}/task_complete`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function quickAddTask(payload) {
  return request(`/tasks/`, {
    method: 'POST',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}



// WEBPACK FOOTER //
// ./src/redux/api/job/jobSiteWorkOrders.js